import React from 'react';
import { Link } from 'react-router-dom';
import type { NavLink } from '../types';
import { LandingNavBase, LandingNavLink, LandingBrandMark } from '../../landing-system';

type Props = {
  navLinks: NavLink[];
};

export default function Navbar({ navLinks }: Props) {
  return (
    <LandingNavBase
      tone="dark"
      brand={
        <Link to="/" className="flex items-center gap-3 no-underline">
          <LandingBrandMark
            logoSrc="/brand/kloutsale-logo.png"
            name="Kloutsale"
            tone="dark"
          />
        </Link>
      }
      links={navLinks.map((link) => (
        <LandingNavLink key={link.label} href={link.href} tone="dark">
          {link.label}
        </LandingNavLink>
      ))}
      actions={
        <>
          <Link
            to="/login"
            className="rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm text-white/80 transition hover:bg-white/10 hover:text-white"
          >
            Sign In
          </Link>
          <Link
            to="/signup"
            className="rounded-full bg-[hsl(var(--landing-accent))] px-5 py-2.5 text-sm font-medium text-white shadow-lg shadow-[hsl(var(--landing-accent)/0.35)] transition hover:bg-[hsl(var(--landing-accent-ring))]"
          >
            Start Free
          </Link>
        </>
      }
    />
  );
}
